import Vue from 'vue'
import Vuex from 'vuex'
import soundMap from './soundMap.js'
import companies from './companies.js'
import docs from './docs.js'
import about from './about.js'
import cfg from './../config.js'
import theme from './theme.js'

Vue.use(Vuex)

const config = {
  namespaced: true,
  state: {
    baseURL: cfg.baseURL,
    baseMediaURL: cfg.baseMediaURL,
    cloudinaryBaseUrl: cfg.baseCloudinary
  },
  getters: {
    getImageUrls: state => data => {
      data.effects = data.effects ? `,${data.effects}` : ''
      if (data.name, data.width, data.folder) {
        return {
          retina: `${state.cloudinaryBaseUrl}/c_scale,w_${data.width}${data.effects}/${data.folder}/${data.name}`,
          classic: `${state.cloudinaryBaseUrl}/c_scale,w_${data.width/2}${data.effects}/${data.folder}/${data.name}`
        }
      }
    },
    getUrlsForImageGrid: state => list => {
      let result = []
      list.forEach((elem) => {
        result.push(`${state.cloudinaryBaseUrl}/c_scale,w_500/csepel/fotos/${elem}`)
      })
      return result
    }
  }
}

export default new Vuex.Store({
  modules: {
    config,
    theme,
    soundMap,
    companies,
    docs,
    about
  }
})
